import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, map, shareReplay } from 'rxjs/operators';

import { API_URL, APP_CONFIG } from '@shared/config';

import {
  ApplicationSetting,
  ApplicationSettingCategory,
} from '@shared/models/application.setting.model';
@Injectable()
export class ApplicationSettingService {
  private readonly apiUrl = inject(APP_CONFIG).orApiUrl;
  private readonly httpClient = inject(HttpClient);

  private readonly settingsCache = new Map<
    ApplicationSettingCategory,
    Observable<Record<string, string>>
  >();

  getApplicationSettingValue(
    applicationSetting: ApplicationSetting
  ): Observable<string> {
    return this.loadCategory(applicationSetting.category).pipe(
      map(settings => settings[applicationSetting.key]),
      tap(value => {
        if (value == null || value == undefined) {
          console.error(
            'Error loading application setting',
            applicationSetting.category,
            applicationSetting.key
          );
        }
      })
    );
  }

  protected loadCategory(
    applicationSetingCategory: ApplicationSettingCategory
  ): Observable<Record<string, string>> {
    if (this.settingsCache.has(applicationSetingCategory)) {
      return this.settingsCache.get(applicationSetingCategory)!;
    }

    const req$ = this.httpClient
      .get<ApplicationSetting[]>(
        this.getApplicationSettingUrl(applicationSetingCategory),
        { withCredentials: true }
      )
      .pipe(
        map<ApplicationSetting[], { [key: string]: string }>(
          categorySettings => {
            return categorySettings.reduce((acc: any, setting) => {
              acc[setting.key] = setting?.value;
              return acc;
            }, []);
          }
        ),
        shareReplay(1)
      );

    this.settingsCache.set(applicationSetingCategory, req$);
    return req$;
  }

  public getApplicationSettingUrl(
    applicationSetingCategory: ApplicationSettingCategory
  ): string {
    return `${this.apiUrl}${API_URL.applicationSetting}/${applicationSetingCategory}`;
  }
}
